// src/Components/OwnerSection.js

import React, { useState } from "react";
import { Parallax } from "react-parallax";
import Modal from "./Modal";
import OwnerImageModal from "../Assets/owner.jpg"; // Replace with your owner's image path
import Restaurant from "../Assets/restaurnat.jpg"; // Replace with your parallax background image path

const OwnerSection = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Brief text about the owner
  const ownerBrief =
    "Khizer founded our cafe with a passion for delivering the finest American and Lebanese cuisines. Overcoming numerous challenges, his dedication and love for food have made our establishment a beloved spot in the community.";

  // Detailed story about the owner
  const ownerStory =
    "Khizer's journey in the culinary world began with a humble dream to create a space where American and Lebanese flavors blend seamlessly. Facing numerous obstacles, from sourcing authentic ingredients to perfecting traditional recipes, his unwavering commitment transformed these challenges into opportunities. Today, his vision thrives, offering patrons a unique and delightful dining experience that celebrates both heritage and innovation.";

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  return (
    <div style={{margin:"15rem 0"}}>
    <Parallax
      bgImage={Restaurant} // Replace with your parallax background image URL
      strength={300}
    >
      <div className="owner-section-container full-width" >
        <div className="owner-content">
          <h2 className="owner-title">Meet Our Owner</h2>
          <p className="owner-brief">{ownerBrief}</p> {/* Added brief text */}
          <button className="owner-button" onClick={openModal}>
            Know More About the Owner
          </button>
        </div>
      </div>

      {/* Modal Implementation */}
      <Modal isOpen={isModalOpen} onClose={closeModal}>
        <div className="modal-owner-container">
          <div className="modal-owner-image">
            <img
              src={OwnerImageModal}
              alt="Khizer, the owner of our cafe"
              loading="lazy"
              style={{
                minHeight:"15rem"
              }}
            />
          </div>
          <div className="modal-owner-text">
            <h2>About Khizer</h2>
            <p>{ownerStory}</p>
          </div>
        </div>
      </Modal>
    </Parallax></div>
  );
};

export default OwnerSection;
